import { React, useState, useEffect } from "react"; // eslint-disable-line no-unused-vars
import AdminDashboardLayout from "../../layout/AdminDashboardLayout";
import { DashboardWrapper } from "../dashboard/dashboard.styled";
import CustomerCharts from "./Partials/CustomerCharts";
import TableHeader from "./Partials/TableHeader";
import CustomersTable from "./Sections/customersTable";
import { customerHeaderCells } from "./data";
import { Outlet } from "react-router-dom";
import { useParams, useNavigate } from "react-router";
import Navigation from "./Partials/Navigation";
import FilterCategory from "../../components/ReusableComponents/FilterCategory";
import { Backdrop, CircularProgress } from "@mui/material";
import { TabList } from "./data";
import { getAllCustomers } from "./customersUtils";
import { toast } from "react-toastify";
import { getFilteredTableData } from "../../utils/Utils";

function CustomersPage() {
	let navigate = useNavigate();
	const { id } = useParams();

	// eslint-disable-next-line no-unused-vars
	const [currentTab, setCurrentTab] = useState("general");
	const [loading, setLoading] = useState(false);
	const [tableData, setTableData] = useState([]);
	const [defaultData, setDefaultData] = useState(); //this is default search functionality state
	const [dateFilter, setDateFilter] = useState("6 Months");
	const [userFilter, setUserFilter] = useState("All");
	const [filteredData, setFilteredData] = useState([]);
	const [selected, setSelected] = useState([]);

	useEffect(() => {
		handleDateFilterChange({ target: { value: dateFilter } });
	}, [tableData]);

	useEffect(() => {
		setLoading(true);
		customerData();
	}, []);

	const customerData = async () => {
		setLoading(true);
		try {
			const data = await getAllCustomers();
			if (data.result) {
				setTableData(data.result);
				console.log(data.result);
				setDefaultData(data.result);
				setLoading(false);
			} else {
				toast.error("error fetching customers data");
				setLoading(false);
			}
		} catch (error) {
			console.error(error);
			toast.error("error fetching customers data");
			setLoading(false);
		}
	};

	const handleTabChange = (category) => {
		setCurrentTab(category);
		navigate(`${id}/${category}`);
	};

	const setTab = () => {
		setCurrentTab("");
		navigate("/customer");
	};

	const handleDateFilterChange = (e) => {
		// Filter TableData based on date - All Time, Today, Last 7 days, Last 30 days, Last 6 months, Last 12 months
		let filteredTableData = getFilteredTableData(e.target.value, tableData);
		setDateFilter(e.target.value);
		setFilteredData(filteredTableData);
	};

	const handleUserFilter = (e) => {
		console.log(e.target.value);
		setUserFilter(e.target.value);
	};

	return (
		<AdminDashboardLayout data={tableData} defaultData={defaultData} setData={setTableData}>
			<DashboardWrapper>
				{id ? (
					<>
						<Navigation setTab={setTab} />
						<FilterCategory
							currentTab={currentTab}
							tabList={TabList}
							handleClick={(category) => handleTabChange(category)}
						/>
						<Outlet context={customerData} />
					</>
				) : (
					<>
						<CustomerCharts />
						<TableHeader
							dateFilter={dateFilter}
							userFilter={userFilter}
							handleDateFilterChange={handleDateFilterChange}
							selected={selected}
							customerData={customerData}
							handleUserFilter={handleUserFilter}
						/>

						{
							<CustomersTable
								headCells={customerHeaderCells}
								TableData={filteredData}
								setSelected={setSelected}
								selected={selected}
							/>
						}
					</>
				)}
			</DashboardWrapper>
			{loading && (
				<Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
					<CircularProgress color='inherit' />
				</Backdrop>
			)}
		</AdminDashboardLayout>
	);
}
export default CustomersPage;
